export default (state = [], action) => {
    let { type, payload } = action
    switch (type) {
        case 'HUNT_PLANNER_MORE_FILTER':
            return payload
        case 'LOGOUT':
            return null
        default:
            return state
    }
}
